import { AnalyticsAdapter, EventBase, UserVars } from '@lifeway/frontend-analytics';
import { Intercom } from '../api/intercom';
import { LicensePairedEvent, TrialGrantedEvent } from '../events';
import { normalizeIntercomEventName } from '../utils/normalIntercomEventName';

export class IntercomAdapter implements AnalyticsAdapter {
  // Currently, Intercom is being booted from within AngularJS.
  // We will need to change this when React is setting up the user.
  private isInitialized = true;

  constructor(private readonly api: Intercom) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public emit(...events: EventBase<any, any, any>[]): void {
    events.forEach(event => {
      this.api.trackEvent(normalizeIntercomEventName(event.eventType), {
        domain: event.domain,
        ...event.context,
      });

      // Support for former style of Intercom events in Ministry Grid
      switch (event.constructor) {
        case LicensePairedEvent: {
          this.api.trackEvent('license_paired', {
            itemNumber: event.context.itemNumber,
          });

          const { brandCode, ageCategory } = event.context.curriculum ?? {};
          if (brandCode && ageCategory) {
            const eventName = `${brandCode.toLowerCase()}_${ageCategory.toLowerCase()}_paired`;
            this.api.trackEvent(eventName, { brandCode, ageCategory });
          }
          break;
        }
        case TrialGrantedEvent: {
          const { brandCode, ageCategory } = event.context.curriculum ?? {};
          if (brandCode && ageCategory) {
            const eventName = `${brandCode.toLowerCase()}_${ageCategory.toLowerCase()}_trial_granted`;
            this.api.trackEvent(eventName, { brandCode, ageCategory });
          }
          break;
        }
      }
    });
  }

  public anonymize(): Promise<void> {
    return new Promise(resolve => {
      this.api.shutdown();
      resolve();
    });
  }

  public identify(userVars?: UserVars): Promise<void> {
    return new Promise(resolve => {
      if (typeof userVars === 'undefined') {
        return resolve();
      }

      if (!this.isInitialized) {
        this.api.boot(userVars);
        this.isInitialized = true;
        return resolve();
      }

      this.api.update(userVars);
      resolve();
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public log(level: number, message: string): void {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public viewPage(pageName: string, pageProperties?: Record<string, unknown>): void {}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public updatePage(pageProperties?: Record<string, unknown>): void {}
  public unloadPage(): void {}
}
